export const windowScrollToTop = () => {
  try {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    }, 100);
  } catch (e) {/* no action */}
};
